/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState, useRef} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {useTranslation, initReactI18next} from 'react-i18next'
import {getSalesAreaLetter} from '../../../api/modules/getdatalist'
import {createLetter} from '../../../api/modules/letterconfig'
// import {Editor} from '@tinymce/tinymce-react'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import {Spinner} from 'react-bootstrap'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'

import Editor from 'src/app/components/Editor'

type Props = {
  className: string
}

const AddLetter: React.FC<Props> = ({className}) => {
  const intl = useIntl()
  const {t} = useTranslation()

  const [tiny, setTiny] = useState<any>()

  const editorRef: any = useRef()

  const onClickHandler = () => {
    setTiny(editorRef.current.getContent())
  }

  var parse: any = require('html-react-parser')

  const [fullSales, setFullSales] = useState<any[]>([])
  const [sales, setSales] = useState('')
  const [module, setModule] = useState('')
  const [lang, setLang] = useState('')
  const [content, setContent] = useState('')
  const [footer, setFooter] = useState('')
  const [other, setOther] = useState('')
  const [roleUser, setRoleUser] = useState('')
  const navigate = useNavigate()

  const [btnLoading, setBtnLoading] = useState(false)

  useEffect(() => {
    const getSales = async () => {
      await getSalesAreaLetter().then((res) => {
        setFullSales(res.data.data)
      })
    }
    getSales()
    setRoleUser(localStorage.getItem('role-flag')!)
  }, [])

  const handleUpload = async () => {
    setBtnLoading(true)
    let formdata = new FormData()
    if (roleUser == 'salesAnper')
      formdata.append('sales_org_code', localStorage.getItem('sales-organization')!)
    else formdata.append('sales_org_code', sales!)
    formdata.append('module', module!)
    formdata.append('lang', lang)
    formdata.append('content', content!)
    formdata.append('other', other!)
    formdata.append('footer', footer!)

    await createLetter(formdata)
      .then((res) => {
        swal({
          title: `${t('configuration letter submited')}`,
          icon: 'success',
        }).then(() => navigate('/config/letter'))
      })
      .catch((error) => {
        swal({
          closeOnClickOutside: false,
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: `• ${t('Add Configuration Letter')}`})}
      </PageTitle>
      <div className={`card ${className}`}>
        <div className='card-body '>
        <Form.Group className='mb-5' controlId='formBasicPassword'>
            <Form.Label>{t('Module')}</Form.Label>
            <Form.Select
              aria-label='Default select example'
              onChange={(e: any) => setModule(e.target.value)}
            >
              <option selected hidden value=''>
                {t('pilih')} {t('Module')}
              </option>
              <option value='contract'>{t('Contract')}</option>
              <option value='sales-order'>Sales Order</option>
              <option value='booking-code'>{t('booking-code')}</option>
              <option value='sip'>SIP</option>
              <option value='proforma-invoice'>Proforma Invoice</option>
            </Form.Select>
          </Form.Group>

          {module != 'sip' && (
            <Form.Group className='mb-5' controlId='formBasicPassword'>
              <Form.Label>Sales Org</Form.Label>
              <Form.Select
                placeholder='Sales Org'
                disabled={roleUser == 'salesAnper' ? true : false}
                onChange={(e: any) => setSales(e.target.value)}
              >
                <option selected hidden value=''>
                  {t('pilih')} Sales Org
                </option>
                {fullSales.map((data: any) => {
                  return (
                    <>
                      {data.code == localStorage.getItem('sales-organization') ? (
                        <option selected value={data.code}>
                          {data.code} - {data.name}
                        </option>
                      ) : (
                        <option value={data.code}>
                          {data.code} - {data.name}
                        </option>
                      )}
                    </>
                  )
                })}
              </Form.Select>
            </Form.Group>
          )}

          <Form.Group className='mb-5' controlId='formBasicPassword'>
            <Form.Label>{t('bahasa')}</Form.Label>
            <Form.Select
              aria-label='Default select example'
              onChange={(e: any) => setLang(e.target.value)}
            >
              <option selected hidden value=''>
                {t('pilih')} {t('bahasa')}
              </option>
              <option value='id'>Indonesia</option>
              <option value='en'>English</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className='mb-5' controlId='formBasicPassword'>
            <Form.Label>Body/{t('Content')}</Form.Label>
            <Editor
                  data={content}
                  onChange={ ( content ) => {
                      setContent(content)
                  }}
              />
          </Form.Group>

          {module == 'sip' && (
            <>
              <Form.Group className='mb-5' controlId='formBasicPassword'>
                <Form.Label>{t('lain-lain')}</Form.Label>
                <Editor
                      data={other}
                      onChange={ ( other ) => {
                          setOther(other)
                      }}
                  />
              </Form.Group>
              <Form.Group className='mb-5' controlId='formBasicPassword'>
                <Form.Label>{t('Footer')}</Form.Label>
                <Editor
                      data={footer}
                      onChange={ ( footer ) => {
                          setFooter(footer)
                      }}
                  />
              </Form.Group>
            </>
          )}

        </div>

        <div className='d-flex justify-content-end p-8'>
          <Link to={'/config/letter'}>
            <Button className='btn btn-secondary me-2'>{t('berita-batal')}</Button>
          </Link>
          <Button className='btn btn-primary' onClick={() => handleUpload()} disabled={btnLoading}>
            {btnLoading ? (
              <Spinner animation='border' variant='light' size='sm' />
            ) : (
              t('order-kirim')
            )}
          </Button>
        </div>
      </div>
    </>
  )
}

export {AddLetter}
